// Angular imports
import { Component, OnInit, Input, Injector, Output, EventEmitter } from '@angular/core';

// CC-Common imports
import { IconConstants, Utils } from 'cc-common';

// Component imports
import { MPSearchBaseComponent } from '../_base/mp-base-search.component';

// Service imports
import { ServerErrorService } from '../../_services/shared-services/server-error.service';
import { CommunityService } from '../../_services/data-services/community.service';
import { UserService } from '../../_services/data-services/user.service';

// Model imports
import { CommunitySelectorResultDto } from '../../_models/community-selector-result-dto';

@Component({
    selector: 'app-search-community',
    templateUrl: './search-community.component.html',
    styleUrls: ['./search-community.component.scss']
})
export class SearchCommunityComponent extends MPSearchBaseComponent implements OnInit {
    @Output() onCommunitySelect = new EventEmitter<any>();
    @Output() saveLastSearchResult = new EventEmitter<CommunitySelectorResultDto[]>();
    @Input() isQuickSearch: boolean;

    communityList: CommunitySelectorResultDto[] = [];
    iconProduction = IconConstants.PRODUCTION;
    iconTransition = IconConstants.IN_TRANSITION;
    iconTerminate = IconConstants.TERMINATE;
    iconExclamatory = IconConstants.EXCLAMATION_CIRCLE;

    hasRecords = false;
    noRecordMessage: string;
    quickSearchText: string;
    isSmallScreen = false;

    constructor(
        protected readonly injector: Injector,
        private readonly errorService: ServerErrorService,
        private readonly communityService: CommunityService,
        private readonly userService: UserService
    ) {
        super(injector);
        this.hasRecords = !this.isQuickSearch;
    }

    ngOnInit() {
        this.updateScreenSize();
        this.screenService.changed.subscribe(() => this.updateScreenSize());
        if (!!this.searchText && !this.isQuickSearch) {
            this.searchCommunity();
        }
    }

    getStatus(rowData: CommunitySelectorResultDto, status: string): string {
        const date = this.helperService.getDateString(rowData.terminatingDate);
        return Utils.isTrue(rowData.isTerminating) && Utils.notEqualsIgnoreCase(rowData.status, 'Terminated')
            ? `Community will terminate on ${date}`
            : status;
    }

    onCommunityClick(data: CommunitySelectorResultDto): void {
        this.onCommunitySelect.emit(data);

        // Clear the filters
        this.clearFilters();
    }

    private getCommunity(): void {
        this.loadingVisible = true;
        this.communityService.getCommunities().subscribe(
            (data: CommunitySelectorResultDto[]) => {
                this.changeNavigationState();
                this.communityList = data;
                this.communityList.forEach((value) => {
                    const searchFields = [
                        value.communityName,
                        value.locationName,
                        value.managementCompanyName,
                        value.intacctCompanyId
                    ];
                    value.searchExpression = searchFields.join('|');
                });
                this.doQuickSearch();
                this.loadingVisible = false;
            },
            (error) => {
                this.loadingVisible = false;
                this.errorService.displayError(error);
            }
        );
    }

    public searchCommunity() {
        if (this.communityList.length === 0 || this.quickSearchText !== this.searchText) {
            this.getCommunity();
        } else {
            this.doQuickSearch();
        }
    }

    private doQuickSearch(): void {
        if (this.isQuickSearch) {
            this.quickSearchText = this.searchText;
            setTimeout(() => {
                if (!!this.searchResultGrid && !!this.searchResultGrid.instance) {
                    const filtered = this.searchResultGrid.instance.getDataSource().items();
                    this.saveLastSearchResult.emit(filtered);
                    this.hasRecords = filtered.length > 0;
                    this.noRecordMessage = this.hasRecords ? '' : 'There are no communities matching the search term.';
                    if (this.gridFeatures.isSearchVisible === false) {
                        this.gridFeatures.onToolbarAction('ShowSearch');
                    }
                }
            }, 500);
        }
    }

    private updateScreenSize(): void {
        this.isSmallScreen = this.screenService.isSmallScreen();
    }

    private changeNavigationState(): void {
        if (this.isSmallScreen) {
            this.userService.updateSideNavigatorState(false);
        }
    }
}
